import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
if ('scrollRestoration' in window.history) { window.history.scrollRestoration = 'manual'; }

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Register from "./pages/Register";
import Marketplace from "./pages/Marketplace";
import CarDetail from "./pages/CarDetail";
import Checkout from "./pages/Checkout";
import GuestCheckout from "./pages/GuestCheckout";
import GuestVerify from "./pages/GuestVerify";
import GuestNegotiationPage from "./pages/GuestNegotiationPage";
import BookingSuccess from "./pages/BookingSuccess";
import HowItWorks from "./pages/HowItWorks";
import LegalIndex from "./pages/legal/LegalIndex";
import TermsHub from "./pages/legal/TermsHub";
import Contact from "./pages/Contact";
import SupportTicket from "./pages/SupportTicket";
import About from "./pages/legal/About";
import Blog from "./pages/legal/Blog";
import Careers from "./pages/legal/Careers";
import Press from "./pages/legal/Press";
import HelpCenter from "./pages/legal/HelpCenter";
import Safety from "./pages/legal/Safety";
import RenterTermsFull from "./pages/legal/RenterTermsFull";
import HostTermsFull from "./pages/legal/HostTermsFull";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import DataDeletion from "./pages/legal/DataDeletion";
import ListYourCar from "./pages/ListYourCar";
import CustomerDashboard from "./pages/customer/CustomerDashboard";
import OwnerDashboard from "./pages/owner/OwnerDashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import PublicTripScore from "./pages/PublicTripScore";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CurrencyProvider>
          <AuthProvider>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/register" element={<Register />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/legal" element={<LegalIndex />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/support/ticket/:ticketId" element={<SupportTicket />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/press" element={<Press />} />
              <Route path="/help" element={<HelpCenter />} />
              <Route path="/safety" element={<Safety />} />
              <Route path="/legal/terms" element={<TermsHub />} />
              <Route path="/legal/terms/renter" element={<RenterTermsFull />} />
              <Route path="/legal/terms/host" element={<HostTermsFull />} />
              <Route path="/legal/privacy" element={<PrivacyPolicy />} />
              <Route path="/legal/data-deletion" element={<DataDeletion />} />
              <Route path="/list-your-car" element={<ListYourCar />} />
              <Route path="/cars" element={<Marketplace />} />
              <Route path="/cars/:id" element={<CarDetail />} />
              <Route path="/trip/:bookingId" element={<PublicTripScore />} />
              <Route
                path="/checkout/:bookingId"
                element={<Checkout />
                }
              />
              <Route
                path="/booking/:bookingId/success"
                element={
                  <ProtectedRoute>
                    <BookingSuccess />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/booking/:bookingId/cancel"
                element={
                  <ProtectedRoute>
                    <BookingSuccess />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account/*"
                element={
                  <ProtectedRoute roles={["customer", "owner", "admin"]}>
                    <CustomerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/owner/*"
                element={
                  <ProtectedRoute roles={["customer", "owner", "admin"]}>
                    <OwnerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute roles={["admin"]}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            <Route path="/guest/checkout" element={<GuestCheckout />} />
              <Route path="/guest/verify" element={<GuestVerify />} />
              <Route path="/guest/negotiate/:negId" element={<GuestNegotiationPage />} />
          </Routes>
          </AuthProvider>
        </CurrencyProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
